/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Reply_StatusInputs */

const en_wb_support_reply_status = /** @type {(inputs: Wb_Support_Reply_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for review`)
};

const lv_wb_support_reply_status = /** @type {(inputs: Wb_Support_Reply_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatavs pārbaudei`)
};

/**
* | output |
* | --- |
* | "Ready for review" |
*
* @param {Wb_Support_Reply_StatusInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_reply_status = /** @type {((inputs?: Wb_Support_Reply_StatusInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Reply_StatusInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_reply_status(inputs)
	return en_wb_support_reply_status(inputs)
});